import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

// SEE: https://getslick.atlassian.net/browse/GS-12543?focusedCommentId=17355
const bePutEgiftSettings = actionBe('bePutEgiftSettings', ({ AT, ATAG, data }) =>
  endpoint(H.put, 'settings/egift/voucher/salon/:salonId/', { AT, name: ATAG, data }),
);

export default bePutEgiftSettings;
